export default __webpack_public_path__ + "static/media/audio_only.svg";